import React from "react";
import { QuickSearchField } from "app/search/QuickSearchField/QuickSearchField";
import { useQuickSearchResults } from "app/search/hooks";
import { withSectionBox } from "app/layout/Box/Box";

export interface QuickSearchFieldContainerProps {
    widgetMode?: boolean;
    initialValue?: string;
    onEnter?: (searchString: string) => void;
}

export const QuickSearchFieldContainer = ({ widgetMode, initialValue, onEnter }: QuickSearchFieldContainerProps) => {
    const [searchString, setSearchString] = React.useState("");
    const [results, loading] = useQuickSearchResults(searchString);

    React.useEffect(() => {
        if (initialValue) {
            setSearchString(initialValue);
        }
    }, [initialValue]);

    return (
        <QuickSearchField
            value={searchString}
            onChange={setSearchString}
            results={results}
            loadingResults={loading}
            widgetMode={widgetMode}
            onEnter={onEnter}
        />
    );
};

export const QuickSearchFieldContainerWithBox = withSectionBox<QuickSearchFieldContainerProps>(QuickSearchFieldContainer);
